import "./Logotype.css";

const Logotype = () => {
  return (
    <div className="Logotype">
      <img
        src="logo.svg"
        alt="the silhouette of a fire lookout tower"
        className="Logotype-Logo"
      ></img>
      <h1 className="Logotype-Title">Lookout Hunter</h1>
    </div>
  );
};

export default Logotype;
